import axios from "@/lib/axios";

const getCustomer = () => {
  return axios.get("/customer/sessions");
}

export default getCustomer;
